import { createSlice } from "@reduxjs/toolkit"


const favoriteSlice = createSlice({
  name: "favorite",
  initialState: {


    favorite: null,
    favorites: null,
    filteredFavorites: null,
    filter: {
      search: null,
      pagination: null,

    },
    filterFavoriteCount: [
      10, 50, 100, 200, 300
    ],
    pagination: null,

    selectedpagination: 0

  },
  reducers: {

    setFavorite(state, action) {
      state.favorite = action.payload
    },
    setFavorites(state, action) {
      state.favorites = action.payload
    }
    ,
    setFilteredItems(state, action) {
      state.filteredFavorites = action.payload
    }
    ,
    resetFavorites(state) {
      state.favorites = null
      state.filteredFavorites = null
      state.filter = {
        search: null,
        pagination: null,
      }
    }

    ,
    setFilter(state, action) {

      if (Array.isArray(action.payload)) {
        action.payload.map(item => {
          state.filter[item.key] = item.value
        })
      }
      else {
        state.filter[action.payload.key] = action.payload.value
      }


    },
    
    setPagination(state, action) {
      
      state.pagination = action.payload
    },


    setSelectedPagination(state, action) {
      state.selectedpagination = action.payload
    }

  },
});

export default favoriteSlice

export const favoriteActions = favoriteSlice.actions;